// extracted by mini-css-extract-plugin
export default {"main":"Hero_main__5UuRf","underline":"Hero_underline__CCo37"};